import { render } from "./RetrievePasswordPage.vue?vue&type=template&id=2eb0c377&scoped=true"
import script from "./RetrievePasswordPage.vue?vue&type=script&lang=js"
export * from "./RetrievePasswordPage.vue?vue&type=script&lang=js"

import "./RetrievePasswordPage.vue?vue&type=style&index=0&id=2eb0c377&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb0c377"]])

export default __exports__